module.exports = __webpack_public_path__ + "a3e355997552612c1567c68f250e6820.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-ski.png
// module id = 2370
// module chunks = 0